import React from "react"
import { motion } from "framer-motion"
import { Globe, BookOpen, GraduationCap, Plane, Compass, MapPin, Microscope, Laptop, Library, Trophy, PenTool, Lightbulb } from "lucide-react"
import "./HomeBackground.css"

const HomeBackground = () => {
    // Enhanced Elements configuration
    const floatingIcons = [
        { Icon: Globe, top: "15%", left: "10%", size: 48, color: "rgba(6, 182, 212, 0.15)", delay: 0, duration: 25 },
        { Icon: GraduationCap, top: "25%", left: "80%", size: 64, color: "rgba(168, 85, 247, 0.15)", delay: 2, duration: 30 },
        { Icon: Plane, top: "60%", left: "15%", size: 56, color: "rgba(59, 130, 246, 0.15)", delay: 5, duration: 28 },
        { Icon: BookOpen, top: "70%", left: "85%", size: 50, color: "rgba(168, 85, 247, 0.15)", delay: 1, duration: 35 },
        { Icon: Compass, top: "40%", left: "5%", size: 40, color: "rgba(6, 182, 212, 0.1)", delay: 3, duration: 26 },
        { Icon: MapPin, top: "85%", left: "45%", size: 45, color: "rgba(59, 130, 246, 0.1)", delay: 7, duration: 32 },
        { Icon: Microscope, top: "35%", left: "60%", size: 55, color: "rgba(168, 85, 247, 0.12)", delay: 4, duration: 29 },
        { Icon: Laptop, top: "10%", left: "45%", size: 42, color: "rgba(6, 182, 212, 0.12)", delay: 1.5, duration: 31 },
        { Icon: Library, top: "80%", left: "25%", size: 60, color: "rgba(59, 130, 246, 0.12)", delay: 6, duration: 34 },
        { Icon: Trophy, top: "50%", left: "90%", size: 48, color: "rgba(168, 85, 247, 0.1)", delay: 2.5, duration: 27 },
        { Icon: PenTool, top: "20%", left: "30%", size: 38, color: "rgba(6, 182, 212, 0.1)", delay: 8, duration: 33 },
        { Icon: Lightbulb, top: "65%", left: "65%", size: 52, color: "rgba(59, 130, 246, 0.15)", delay: 3.5, duration: 28 },
    ]

    return (
        <div className="home-dynamic-background">
            {/* Dynamic Gradient Orbs - Increased movement */}
            <motion.div
                className="gradient-orb orb-1"
                animate={{
                    x: [0, 150, -50, 100, 0],
                    y: [0, -100, 150, 50, 0],
                    scale: [1, 1.3, 0.9, 1.2, 1],
                }}
                transition={{ duration: 35, repeat: Infinity, ease: "linear" }}
            />
            <motion.div
                className="gradient-orb orb-2"
                animate={{
                    x: [0, -200, 100, -150, 0],
                    y: [0, 150, -100, -50, 0],
                    scale: [1, 1.4, 0.85, 1.1, 1],
                }}
                transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
            />
            <motion.div
                className="gradient-orb orb-3"
                animate={{
                    x: [0, 150, -150, 200, 0],
                    y: [0, -150, 100, -100, 0],
                    scale: [1, 0.9, 1.25, 0.95, 1],
                }}
                transition={{ duration: 45, repeat: Infinity, ease: "linear" }}
            />

            {/* Grid Pattern Overlay */}
            <div className="background-grid-pattern" />

            {/* Floating Education Icons */}
            <div className="floating-icons-container">
                {floatingIcons.map((item, index) => {
                    // Generate unique, wide movement paths for each icon based on index
                    const randomX1 = (index % 2 === 0 ? 1 : -1) * (30 + (index * 5));
                    const randomX2 = (index % 3 === 0 ? -1 : 1) * (50 + (index * 8));
                    const randomY1 = (index % 2 !== 0 ? 1 : -1) * (40 + (index * 6));
                    const randomY2 = (index % 3 !== 0 ? -1 : 1) * (60 + (index * 7));
                    const randomR1 = (index % 2 === 0 ? 1 : -1) * (20 + (index * 2));
                    const randomR2 = (index % 3 === 0 ? -1 : 1) * (45 + (index * 3));

                    return (
                        <motion.div
                            key={index}
                            className="floating-icon"
                            style={{ top: item.top, left: item.left, color: item.color }}
                            initial={{ y: 0, x: 0, rotate: 0 }}
                            animate={{
                                y: [0, randomY1, randomY2, randomY1 / 2, 0],
                                x: [0, randomX1, randomX2, randomX1 / 2, 0],
                                rotate: [0, randomR1, randomR2, randomR1 / 2, 0]
                            }}
                            transition={{
                                duration: item.duration,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: item.delay
                            }}
                        >
                            <item.Icon size={item.size} strokeWidth={1} />
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default HomeBackground
